export default __webpack_public_path__ + "static/media/gallery32.8082cb2e.webp";